import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, imprimirCrvle } from './types';

export const INITIAL_STATE: imprimirCrvle = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): imprimirCrvle {
	return produce(state, draft => {
		switch (action.type) {
			case Types.IMPRIMIR_CRLVE_REQUEST: {
				break;
			}

			case Types.IMPRIMIR_CRLVE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.IMPRIMIR_CRLVE_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.IMPRIMIR_CRLVE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
